export const timeWindows = {
  anytime: 'Anytime (8am-8pm)',
  morning: 'Morning (8am-12pm)',
  afternoon: 'Afternoon (12pm-4pm)',
  evening: 'Evening (4pm-8pm)',
};

export const bufferTime = 0; // hours
